import {isLoggedIn} from 'utils/auth'

export default (store) => {
  return ({
    path: 'edit-customer-group/:code',
    onEnter: isLoggedIn(store),
    getComponent(nextState, cb) {
      require.ensure([], (require) => {
        const CustomerGroup = require('./containers/EditCustomerGroup').default;
        cb(null, CustomerGroup)
      }, 'customerGroup')
    }
  })
}



// WEBPACK FOOTER //
// ./src/routes/CustomerGroup/EditCustomerGroup/index.js